<template>
  <div>
    <!-- Filters -->
    <v-layout row justify-end wrap class="mb-5">
      <v-flex xs12 md6>
        <div class="ml-3">
          <v-text-field
            v-model="filters.search"
            append-icon="search"
            label="Buscar"
            single-line
            hide-details
          ></v-text-field>
        </div>
      </v-flex>
    </v-layout>
    <!-- Data table with invoices -->
    <v-data-table
      ref="openBillingProductTable"
      v-model="selectedItems"
      :loading="loading"
      :headers="headers"
      :items="products"
      :pagination.sync="productsPagination"
      :rows-per-page-items="[10, 20, 30, 50, 100]"
      :total-items="productsPagination.totalItems"
      select-all
    >
      <template v-slot:no-data>
        <v-alert :value="true" color="info" icon="info" outline>
          {{ $t('No hay información que mostrar con los filtros seleccionados :(') }}
        </v-alert>
      </template>
      <template v-slot:headers="props">
        <tr>
          <th v-if="props.headers.length > 0" class="text-xs-center width-40px">
            <v-checkbox
              v-model="selectAllRows"
              @change="selectAllTableRows()"
              primary
              hide-details
            ></v-checkbox>
          </th>
          <template v-for="header in props.headers">
            <th
              :key="`th_${header.value}`"
              :class="[
                `text-xs-${header.align ? header.align : 'center'}`,
                header.sortable ? 'column sortable' : '',
                productsPagination.descending ? 'desc' : 'asc',
                header.value === productsPagination.sortBy ? 'active' : '',
              ]"
              @click="header.sortable ? changeSort(header.value) : null"
            >
              <v-icon v-if="header.sortable" small>arrow_upward</v-icon>
              {{ header.text }}
            </th>
          </template>
          <th v-if="props.headers.length > 0" class="text-xs-center">ACCIONES</th>
        </tr>
      </template>
      <template v-slot:items="props">
        <tr>
          <td class="width-40px">
            <v-checkbox v-model="props.selected" primary hide-details></v-checkbox>
          </td>
          <td
            v-for="header in headers"
            :key="header.value"
            :class="[`text-xs-${header.align ? header.align : 'center'}`]"
          >
            <template v-if="header.value === 'invoice_type'">
              <template v-for="item in props.item[header.value]">
                <v-chip
                  text-color="white"
                  :key="Math.random() + item"
                  :color="item === 'Venta' ? 'success' : 'orange'"
                >
                  <strong>{{ item }}</strong>
                </v-chip>
              </template>
            </template>
            <template v-else-if="header.value === 'type'">
              <v-chip color="grey" text-color="white">
                <strong>{{ props.item[header.value] }}</strong>
              </v-chip>
            </template>
            <template v-else-if="header.value === 'price'">
              {{
                props.item[header.value]
                  ? props.item[header.value] + ' €'
                  : props.item[header.value]
              }}
            </template>
            <template v-else-if="header.value === 'tax'">
              {{
                props.item[header.value]
                  ? props.item[header.value] + ' %'
                  : props.item[header.value]
              }}
            </template>
            <template v-else>
              {{ props.item[header.value] }}
            </template>
          </td>
          <td class="text-xs-center">
            <v-icon small class="mr-2" @click="editProduct(props.item)">
              edit
            </v-icon>
            <v-icon small @click="deleteProduct(props.item)">
              delete
            </v-icon>
          </td>
        </tr>
      </template>
    </v-data-table>
  </div>
</template>

<script>
import apiCtrl from '@/services/api/abstract/abstract-api';

export default {
  name: 'OpenBillingProductTable',
  components: {},
  props: [],
  data() {
    return {
      products: [],
      selectedItems: [],
      selectAllRows: false,
      loading: false,
      headers: [],
      productsPagination: {
        descending: true,
        page: 1,
        rowsPerPage: 10, // -1 for All",
        sortBy: '',
        totalItems: 0,
      },
      filters: {
        search: '',
      },
      sortTable: false,
    };
  },
  mounted() {
    this.getBillingProducts();
  },
  computed: {
    currentPage() {
      return this.productsPagination.page;
    },
    perPage() {
      return this.productsPagination.rowsPerPage;
    },
    sortBy() {
      return this.productsPagination.sortBy;
    },
    descending() {
      return this.productsPagination.descending;
    },
    billingProfileId() {
      return this.$store.getters.currentOpenbillingProfileId;
    },
    clavedat() {
      return this.$store.state.clavedat;
    },
    search() {
      return this.filters.search;
    },
  },
  methods: {
    getBillingProducts() {
      this.loading = true;
      const config = {
        params: {
          page: this.productsPagination.page,
          per_page: this.productsPagination.rowsPerPage,
          sort_by: this.productsPagination.sortBy,
          descending: this.productsPagination.descending,
          search: this.filters.search,
        },
      };
      apiCtrl
        .get(`/openbilling/${this.clavedat}/products/list`, config)
        .then(res => {
          this.products = res.data.data;
          this.headers = res.data.dataTable.headers;
          this.productsPagination = {
            descending: this.productsPagination.descending,
            page: this.productsPagination.page,
            rowsPerPage: Number(res.data.meta.per_page), // -1 for All",
            sortBy: this.productsPagination.sortBy,
            totalItems: Number(res.data.meta.total),
          };
          this.loading = false;
        })
        .catch(() => {
          this.loading = false;
        });
    },
    selectAllTableRows() {
      if (
        this.selectedItems.length === 0 ||
        (this.selectedItems.length >= 1 && this.selectedItems.length < this.products.length)
      ) {
        let selected = [];
        this.products.forEach(item => {
          selected.push(item);
        });
        this.selectedItems = selected;
      } else if (this.selectedItems.length === this.products.length) {
        if (this.selectAllRows) {
          this.selectedItems = this.products;
        } else {
          this.selectedItems = [];
        }
      }
    },
    changeSort(column) {
      if (this.productsPagination.sortBy === column) {
        this.productsPagination.descending = !this.productsPagination.descending;
      } else {
        this.productsPagination.sortBy = column;
        this.productsPagination.descending = false;
      }
    },
    editProduct(product) {
      this.$emit('on-edit-product', product);
    },
    deleteProduct(product) {
      this.$emit('on-delete-product', product);
    },
    getBillingProductsIfStopChanges() {
      this.loading = true;
      const params = {
        page: this.productsPagination.page,
        per_page: this.productsPagination.rowsPerPage,
        search: this.filters.search,
      };

      setTimeout(() => {
        if (
          params.page === this.productsPagination.page &&
          params.per_page === this.productsPagination.rowsPerPage &&
          params.search === this.filters.search
        ) {
          this.getBillingProducts();
        }
      }, 300);
    },
  },
  watch: {
    search: function() {
      if (this.currentPage === 1) {
        this.getBillingProductsIfStopChanges();
      } else {
        this.productsPagination.page = 1;
      }
    },
    currentPage: function() {
      this.getBillingProductsIfStopChanges();
    },
    perPage: function() {
      if (this.currentPage === 1) {
        this.getBillingProductsIfStopChanges();
      } else {
        this.productsPagination.page = 1;
      }
    },
    sortBy: function() {
      if (this.sortBy != null && this.sortTable) {
        this.getBillingProducts();
      } else {
        if (this.descending === null) {
          this.sortTable = false;
        }
      }
    },
    descending: function() {
      if (this.descending != null) {
        this.getBillingProducts();
        this.sortTable = true;
      } else {
        if (this.sortBy === null) {
          this.sortTable = false;
        }
      }
    },
    selectedItems: function() {
      this.$emit('on-selected-items', this.selectedItems);
    },
  },
};
</script>

<style scoped>
.width-40px {
  width: 40px;
}
</style>
